import gql from "graphql-tag";

export const GET_VENDORS = gql`
query {
  vendors {
    id
    name
    description
    projectId
    project {
      id
      name
    }
    created
    lastModified
  }
}
`;

export const GET_VENDOR = gql`
query vendor($id: Float!) {
  vendor(id: $id) {
    id
    name
    description
    projectId
    project {
      id
      name
    }
    vendorLayers {
      id
      layerId
      layer {
        id
        name
        project {
          id
          name
        }
      }
    }
    created
    lastModified
  }
}
`;

export const CREATE_VENDOR = gql`
mutation createVendor($name: String!, $description: String, $projectId: Float) {
  createVendor(vendor: {
    name: $name
    description: $description
    projectId: $projectId
  }) {
    id
    name
    description
    projectId
    project {
      id
      name
    }
    created
    lastModified
  }
}
`;

export const UPDATE_VENDOR = gql`
mutation updateVendor($id: Float!, $name: String!, $description: String, $projectId: Float) {
  updateVendor(vendor: {
    id: $id
    name: $name
    description: $description
    projectId: $projectId
  }) {
    id
    name
    description
    projectId
    project {
      id
      name
    }
    created
    lastModified
  }
}
`;

export const DELETE_VENDOR = gql`
mutation deleteVendor($id: Float!) {
  deleteVendor(id: $id)
}
`;

export const GET_VENDOR_LAYERS = gql`
query {
  vendorLayers {
    vendorId
    layerId
    vendor {
      id
      name
      project {
        id
        name
      }
    }
    layer {
      id
      name
    }
  }
}
`;

export const GET_VENDOR_LAYERS_BY_VENDOR = gql`
query vendorLayersByVendorId($vendorId: Float!) {
  vendorLayersByVendorId(vendorId: $vendorId) {
    vendorId
    layerId
    vendor {
      id
      name
      project {
        id
        name
      }
    }
    layer {
      id
      name
    }
  }
}
`;

export const CREATE_VENDOR_LAYER = gql`
mutation createVendorLayer($vendorId: Float!, $layerId: Float!) {
  createVendorLayer(vendorLayer: {
    vendorId: $vendorId
    layerId: $layerId
  }) {
    vendorId
    layerId
    vendor {
      id
      name
      project {
        id
        name
      }
    }
    layer {
      id
      name
    }
  }
}
`;

export const UPDATE_LAYER_GROUP = gql`
mutation updateLayerGroup($layerId: Float!, $vendorId: Float) {
  updateLayerGroup(layerId: $layerId, vendorId: $vendorId) {
    vendorId
    layerId
    vendor {
      id
      name
      project {
        id
        name
      }
    }
    layer {
      id
      name
    }
  }
}
`;

export const DELETE_VENDOR_LAYER = gql`
mutation deleteVendorLayer($vendorId: Float!, $layerId: Float!) {
  deleteVendorLayer(vendorId: $vendorId, layerId: $layerId)
}
`;

export const SEARCH_VENDORS = gql`
query searchVendors($searchTerm: String!) {
  searchVendors(searchTerm: $searchTerm) {
    id
    name
    description
    projectId
    project {
      id
      name
    }
    created
    lastModified
  }
}
`;
